// src/components/notary-completed.js

import React, { useState, Fragment, useEffect } from 'react';
import { RestHelper } from '../helper/restHelper'
import RonBadge, { isRon } from './ron-badge'
import { NotaryViewRequestDetails } from '../components'



const NotaryCompleted = (profileEmail) => {
  const [message, setApiRes] = useState([])
  const [viewState, setViewState] = useState(false)
  const [viewRequest, setViewRequest] = useState(false)
  const [requestId, setRequestId] = useState('')
  const [dataFetched, setDataFetched] = useState(false)


  const activeUser = {'activeUser': profileEmail.profileEmail }
  const action = {'action' : 'Completed'}
 
  const api = RestHelper()
 
  useEffect (() => {
    changeView();
  }, []);

  // if Check Pending Requests is selected, we'll query for pending requests


  const changeView = () => {
    if (viewState){
        setViewState(false);
        setViewRequest(false)
        setDataFetched(false)
        setApiRes([])
    }
    else{
    setViewState(true);
    setViewRequest(false)
    const options = {}
    if(!dataFetched){
        api
            .postCreate('/get-notary-open-requests', options, action)
            .then(res => setApiRes(res))
            .catch(err => console.log(err))
        }
        setDataFetched(true)
    }
  }

  const getRequest = (data) => {
    setRequestId(data.RequestId)
    setViewRequest(true);
    setViewState(false)
  }
  

  return(
    <div>
  {viewRequest
    ? (<div className='container mb-3 border rounded bg-light'>
        <div className='row rounded bg-white'>
            <button className="close ml-3 mb-2 mt-2" aria-label="Close" onClick={() =>changeView()}>
                <span aria-hidden='false'>&times;</span>
            </button>
        </div>
        <Fragment>
            <NotaryViewRequestDetails requestId={requestId} status='completed'/>
         </Fragment>
        </div>)
    : <div></div>
    }
  {viewState && (
        <div className="mt-5">
          <h6 className="muted">Here are your recently completed requests:</h6>
          <div className="space-y-3">
                    {message.map((items =>
                         <div className='order-card' key={items.RequestId}>
                           <div className="order-card-header">
                             <button className='btn btn-primary btn-sm' type='button' onClick={() => getRequest(items)}>{items.Appt_Name} Details</button>{isRon(items.Appt_Ron) && <RonBadge className="ml-2" />}
                           </div>
                           <div className="order-card-row">
                             <div className="order-card-label">Status</div>
                             <div className="order-card-value">{items.Status}</div>
                           </div>
                           <div className="order-card-row">
                             <div className="order-card-label">Location</div>
                             <div className="order-card-value">{items.Appt_City}, {items.Appt_State}</div>
                           </div>
                           <div className="order-card-row">
                             <div className="order-card-label">Appointment Date</div>
                             <div className="order-card-value">{items.Appt_Date}</div>
                           </div>
                           <div className="order-card-row">
                             <div className="order-card-label">Signing Agent Fee</div>
                             <div className="order-card-value">${items.Appt_Bid}</div>
                           </div>
                         </div>
                    ))}
          </div>
        </div>
      )}
</div>
  )
};

export default NotaryCompleted;